module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/Hero_Crown@2x-f81442a7601ae0c6.png"+" 103w",
        images: [{path: __webpack_public_path__ + "assets/images/Hero_Crown@2x-f81442a7601ae0c6.png",width: 103,height: 106}],
        src: __webpack_public_path__ + "assets/images/Hero_Crown@2x-f81442a7601ae0c6.png",
        toString: function(){return __webpack_public_path__ + "assets/images/Hero_Crown@2x-f81442a7601ae0c6.png"},
        
        width: 103,
        height: 106
      }